import { useQuery } from 'react-query'

import { restrictedWordsService } from '@/modules/restricted-words/service/restricted-words-service.ts'
import { handleError } from '@/utils/error'

export function useRestrictedWordsSettings() {
  const { data, isLoading, isFetching } = useQuery(
    'restrictedWordsSettings',
    restrictedWordsService.getRestrictedWordsSettings,
    {
      onError: (error) =>
        handleError(error, 'Failed to get restricted words settings'),
    },
  )

  return {
    settings: data,
    isRestrictedWordsSettingsLoading: isLoading,
    isRestrictedWordsSettingsFetching: isFetching,
  }
}
